module.exports = __webpack_public_path__ + "static/media/undraw_hiring_amber.36c688d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/undraw_hiring_amber.svg
// module id = 1096
// module chunks = 2